import { Text, VStack } from "@project/ui";
import { useMicrocopy } from "@/lib/contentful/microcopy/microcopy-context";

type ArticleReadingTimeComponentProps = {
    readingTime: number;
};

export const ArticleReadingTimeComponent = (props: ArticleReadingTimeComponentProps) => {
    const { readingTime } = props;

    const { get: getMicrocopy } = useMicrocopy();

    return (
        <VStack align="start" spacing={2}>
            <Text size="caption" color="grey300">
                {getMicrocopy("pageArticlePage", "text.readingTime")}
            </Text>
            <Text size="caption">
                {readingTime} {getMicrocopy("pageArticlePage", "text.readingTimeValue")}
            </Text>
        </VStack>
    );
};
